import {inputTools} from "./constant";

export function isSpeechToText(toolName) {
    // Check if the tool exists in the inputTools object and if its type is 'speechToText'
    return inputTools[toolName] && inputTools[toolName].type === 'speechToText';
}